// eslint-disable-next-line
import { Box, Typography } from '@mui/material'
// eslint-disable-next-line
import { MRT_ColumnDef } from 'material-react-table'
import { useMemo } from 'react'
import { useAppSelector } from '../../app/hooks'
import { useGetTransportJobsQuery } from '../../app/redux-fetch/apiQuery'
import MRTDataGridv2 from '../../components/MRTDataGrid/MRTDataGridv2'
import { TableTitleTypography } from '../../components/Typographies/TableTitleTypography'
import { fetchLoggedInUserSelector } from '../selectors'
import { ILoggedInUser } from '../types'
import TransportJobLoads from './TransportJobLoads'
import { TransportJob } from './types'

const TransportJobTable = () => {
  const loggedInUser = useAppSelector(fetchLoggedInUserSelector.data) || ({} as ILoggedInUser)
  const tenantId = loggedInUser.tenantId ?? -1

  const { data, isLoading } = useGetTransportJobsQuery(tenantId)
  // eslint-disable-next-line
  const transportJobColumns = useMemo<Array<MRT_ColumnDef<TransportJob>>>(() => {
    // eslint-disable-next-line
    const columns: Array<MRT_ColumnDef<TransportJob>> = [
      {
        header: 'Destinations',
        accessorFn: (row) => {
          const destinations = row.route?.destinations ?? []
          return destinations.map((d, index) => (
            <Typography key={d.id}>
              {d.location?.name ?? '-'}
              {index !== destinations.length - 1 && <> &gt;</>}
            </Typography>
          ))
        },
      },
      {
        header: 'Drivers',
        accessorFn: (row) => {
          const userNames = (row.assetGroup?.assetAllocations ?? [])
            .flatMap((assetAllocation) => assetAllocation.userAllocations ?? [])
            .filter((userAllocation) => userAllocation.isDriver)
            .map((userAllocation) => `${userAllocation.user?.firstName} ${userAllocation.user?.lastName}`)
          return userNames.map((d, index) => <Typography key={index}>{d}</Typography>)
        },
      },
      {
        header: 'Assets',
        accessorFn: (row) => {
          const identifications = (row.assetGroup?.assetAllocations ?? []).map(
            (assetAllocation) => assetAllocation.asset?.identification
          )
          return identifications.map((d, index) => <Typography key={index}>{d}</Typography>)
        },
      },
    ]
    return columns
  }, [data])

  return <MRTDataGridv2
    initialState={{
      pagination: { pageSize: 100, pageIndex: 0 },
    }}
    state={{ isLoading: isLoading }}
    leftHeadingComponent={
      <Box sx={{ display: 'inline-flex' }}>
        <TableTitleTypography>Transport Jobs</TableTitleTypography>
      </Box>
    }
    columns={transportJobColumns}
    data={data || []}
    getRowId={(row) => row.id as any}
    enableExpanding
    positionActionsColumn='last'
    renderDetailPanel={({ row }) => <TransportJobLoads tenantId={tenantId} transportJob={row.original} />}
  />
}

export default TransportJobTable
